import React from "react";
import propTypes from "prop-types";
import { VehicleAuditIssue, VehicleAuditIssueType } from "../../../../logic/api";
import styles from "./styles";

import {
    FiAlertTriangle,
    FiChevronRight,

} from 'react-icons/fi';

import flex from "../../../../styles/flex";
import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";


import { IoMdCar } from "react-icons/io";
import { formatCamel } from "../../../../utility/utils";
import usePaths from "../../../../utility/paths";
import { useTranslation } from "react-i18next";


const VehicleAuditViewIssueListItem: React.FunctionComponent<{
    item: VehicleAuditIssue,
}> = (props) => {
    const paths = usePaths();
    const auditIssueTypes: string[] = [];
    const { t } = useTranslation();

    const keys = Object.keys(VehicleAuditIssueType);
    for (let i = 0; i < keys.length; i++) {
        if (isNaN(parseInt(keys[i]))) {
            auditIssueTypes.push(keys[i]);
        }
    }

    return <div style={{ ...styles.listItem }} onClick={() => {
        window.open(paths.booking(props.item.booking.id));
    }}>
        <div style={{ position: "absolute", textAlign: "center", width: 120, left: -67, bottom: 0, height: 15, top: 30, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", color: "white", transform: "rotate(270deg)" }}>
            <span>{t("lists.issue")}</span>
        </div>

        <div style={styles.listItemFlex}>

            <ListViewItemCard
                icon={<IoMdCar style={styles.icon} />}
                text={props.item.booking.vehicle.registration}
                subText={`${props.item.booking.vehicle.colour}, ${props.item.booking.vehicle.make}, ${props.item.booking.vehicle.model}`}
            />
            <ListViewItemCard
                icon={<FiAlertTriangle style={styles.icon} />}
                text={t("lists.issue")}
                subText={formatCamel(auditIssueTypes[props.item.issueType])}
            />



            <div style={flex.flexAuto}>
                <div style={{ ...flex.flexRows, alignItems: "center", height: "100%" }}>
                    <div style={flex.flexAuto}>
                        <FiChevronRight style={styles.iconChevron} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}


VehicleAuditViewIssueListItem.propTypes = {
    item: propTypes.any.isRequired
};


export default VehicleAuditViewIssueListItem;